export default "__VITE_ASSET__CmoATHTB__"